import Analyze from "./Analyze.jsx";

export default Analyze;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analyze/index.js